import { Country } from '@tecex-api/data';
import { Observable } from 'rxjs';

export abstract class BaseCountryService {
  public abstract getAllCountries$(): Observable<Country[]>;
  public abstract getDestinationCountries$(): Observable<Country[]>;
}
